import { useEffect, useState } from "react";
import { FiX, FiCheck } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "../../styles/PresetModal.css";

import dineInImg from "../../assets/dine-in.jpg";
import deliveryImg from "../../assets/delivery.jpg";

const ANIM_MS = 250;

export default function PresetModal({
  open,
  onClose,
  value = "dine_in",
  onConfirm,
  isLoggedIn = false,
onLogin,
}) {
  const { t } = useTranslation("preset");

  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);
  const [preset, setPreset] = useState(value);

  useEffect(() => {
    setPreset(value || "dine_in");
  }, [value, open]);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
      return;
    }

    if (mounted) {
      setClosing(true);
      const tmr = setTimeout(() => {
        setMounted(false);
        setClosing(false);
      }, ANIM_MS);
      return () => clearTimeout(tmr);
    }
  }, [open, mounted]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }

    if (mounted) {
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [mounted, onClose]);

  if (!mounted) return null;

  return (
    <div
      className={`pmOverlay ${open && !closing ? "isOpen" : "isClosing"}`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="preset-modal-title"
    >
      <div className="pmCard" onClick={(e) => e.stopPropagation()}>
        <div className="pmHeader">
          <div className="pmHeaderText">
            <div className="pmTitle" id="preset-modal-title">
              {t("title")}
            </div>
            <div className="pmSubtitle">
              {t("subtitle")}
            </div>
          </div>

          <button
            type="button"
            className="pmClose"
            onClick={onClose}
            aria-label={t("close")}
          >
            <FiX />
          </button>
        </div>

        <div className="pmGrid">
          <button
            type="button"
            className={`pmChoice ${preset === "dine_in" ? "isActive" : ""}`}
            onClick={() => setPreset("dine_in")}
          >
            <div className="pmChoiceImageWrap">
              <img
                src={dineInImg}
                alt={t("dine_in_alt")}
                className="pmChoiceImage"
              />
              <div className="pmChoiceOverlay" />
              <div className="pmChoiceBadge">
                <FiCheck />
              </div>
            </div>

            <div className="pmChoiceFooter">
              <div className="pmChoiceTitle">{t("dine_in_title")}</div>
              <div className="pmChoiceText">
                {t("dine_in_text")}
              </div>
            </div>
          </button>

          <button
            type="button"
            className={`pmChoice ${preset === "delivery" ? "isActive" : ""}`}
            onClick={() => setPreset("delivery")}
          >
            <div className="pmChoiceImageWrap">
              <img
                src={deliveryImg}
                alt={t("delivery_alt")}
                className="pmChoiceImage"
              />
              <div className="pmChoiceOverlay" />
              <div className="pmChoiceBadge">
                <FiCheck />
              </div>
            </div>

            <div className="pmChoiceFooter">
              <div className="pmChoiceTitle">{t("delivery_title")}</div>
              <div className="pmChoiceText">
                {t("delivery_text")}
              </div>
            </div>
          </button>
        </div>

        <div className="pmActions">
          {!isLoggedIn && (
  <div className="pmAuthNotice">
    {t("auth_notice")}
  </div>
)}

<button
  type="button"
  className={`pmConfirm ${!isLoggedIn ? "pmLoginBtn" : ""}`}
  onClick={() => {
    if (!isLoggedIn) {
      onLogin?.();
      return;
    }

    onConfirm?.(preset);
  }}
>
  {isLoggedIn ? t("continue") : t("login")}
</button>
        </div>
      </div>
    </div>
  );
}